"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ETargetPage = exports.EFields = void 0;
/* eslint-disable  @typescript-eslint/no-explicit-any */
/**
 * Список страниц, где будут использованы фильтры
 * */
let ETargetPage = exports.ETargetPage = /*#__PURE__*/function (ETargetPage) {
  ETargetPage[ETargetPage["valuation"] = 0] = "valuation";
  ETargetPage[ETargetPage["valuationResults"] = 1] = "valuationResults";
  // старый realty-valuation-results-frontend
  ETargetPage[ETargetPage["newBuilding"] = 2] = "newBuilding";
  ETargetPage[ETargetPage["realtorPromo"] = 3] = "realtorPromo";
  //select-realtor-promo-frontend
  ETargetPage[ETargetPage["valuationAgentResults"] = 4] = "valuationAgentResults";
  //valuation-for-agent-frontend, <ReportPageContainer />
  ETargetPage[ETargetPage["valuationForAgentCalculatorPage"] = 5] = "valuationForAgentCalculatorPage";
  //valuation-for-agent-frontend, <CalculatorPageContainer />
  ETargetPage[ETargetPage["myHomePage"] = 6] = "myHomePage";
  //valuation-my-home-page-frontend
  ETargetPage[ETargetPage["myHomeCard"] = 7] = "myHomeCard"; //valuation-my-home-card-frontend
  return ETargetPage;
}({});
/**
 * Список доступных полей
 */
let EFields = exports.EFields = /*#__PURE__*/function (EFields) {
  EFields["flatNumber"] = "flatNumber";
  EFields["roomsCount"] = "roomsCount";
  EFields["area"] = "area";
  EFields["address"] = "address";
  EFields["estimationTarget"] = "estimationTarget";
  EFields["landArea"] = "landArea";
  EFields["houseArea"] = "houseArea";
  return EFields;
}({});
/**
 * Интерфейсы пропсов отдельных фильтров, приходящих в виджет из места использования
 * */
/** Пропсы для первичного фильтра "Тип оцениваемого объекта" */
/** Пропсы для фильтра "Кол-во комнат" */
/** Пропсы для фильтра "Площадь" */
/** Пропсы для фильтра "Адрес" */
/** Пропсы для фильтра Квартира */